/** Canonical severity levels — see DESIGN_SYSTEM.md §9. */
export const SEVERITY_LEVELS = ['critical', 'high', 'medium', 'low', 'info'] as const;
export type Severity = (typeof SEVERITY_LEVELS)[number];

interface SeverityToken {
  /** Tailwind class fragment for the dot/pill background color. */
  bg: string;
  /** Tailwind class fragment for foreground color when on a sev background. */
  fg: string;
  /** Tailwind class fragment for a subtle tinted background (rows, banners). */
  subtle: string;
  /** Text color used on the tinted (subtle) treatment. */
  ink: string;
  /** Human-readable label for status pills. */
  label: string;
}

/**
 * The single source of severity → token mapping. Used by `<SeverityBadge />`,
 * status dots, alert banners, and timeline events. Adding a new severity
 * level requires updating both this map and the design-system spec.
 */
export const SEVERITY_TOKENS: Record<Severity, SeverityToken> = {
  critical: { bg: 'bg-sev-critical', fg: 'text-white', subtle: 'bg-sev-critical-subtle', ink: 'text-sev-critical', label: 'Critical' },
  high: { bg: 'bg-sev-high', fg: 'text-white', subtle: 'bg-sev-high-subtle', ink: 'text-sev-high', label: 'High' },
  medium: { bg: 'bg-sev-medium', fg: 'text-[#1c1b19]', subtle: 'bg-sev-medium-subtle', ink: 'text-[#8a6808]', label: 'Medium' },
  low: { bg: 'bg-sev-low', fg: 'text-white', subtle: 'bg-sev-low-subtle', ink: 'text-sev-low', label: 'Low' },
  info: { bg: 'bg-sev-info', fg: 'text-white', subtle: 'bg-sev-info-subtle', ink: 'text-sev-info', label: 'Info' },
};

export function severity(level: Severity): SeverityToken {
  return SEVERITY_TOKENS[level];
}
